export default __webpack_public_path__ + "static/media/export.748748b1.svg";